"use strict";

import PopinManager from "./popinManage";

const Header = {
    el: null,
    toggle: null,
    overlay: null,
    nav: null,
    init: function () {
        Header.el = document.querySelector(".header");
        Header.overlay = Header.el.querySelector(".header__overlay");
        Header.toggle = Header.el.querySelector(".header__toggle");
        Header.close = Header.el.querySelector(".header__nav-close");
        Header.nav = Header.el.querySelector(".header__nav");


        if (Header.el && Header.nav) {

            Header.menuConstructor();

            // Toggle button
            if (Header.toggle) {
                Header.toggle.addEventListener("click", (e) => Header.openMenu(e));
                Header.close.addEventListener("click", (e) => Header.closeMenu(e));
            }
            // Accessibility
            const skipLinksToggle = document.querySelector(".skiplinks__menuBtn");
            if (skipLinksToggle) {
                skipLinksToggle.addEventListener("click", (e) => {
                    Header.openMenu(e);
                });
            }


            // Click outside menu
            Header.navCtn = Header.nav.querySelector(".header__nav-ctn");
            document.addEventListener("click", (event) => {
                if (Header.el.classList.contains("navOpened") && !Header.navCtn.contains(event.target) && !Header.toggle.contains(event.target) && !event.target.classList.contains("skiplinks__menuBtn") || (event.target.classList.contains('submenu') && event.target.classList.contains('show--') )) {
                    //console.log('click outside');
                    Header.closeMenu(event);
                }
            });
        }
    },
    openMenu: function (e) {
        // Create a reference to this for use in the keydown handler
        const self = this;

        // Named handler function that can be added and removed
        this.keydownHandler = function(e) {
            PopinManager.trapFocus(self.nav, e, function(e) {
                self.closeMenu(e);
            });
        };

        Header.el.classList.add("navOpened");
        document.addEventListener("keydown", this.keydownHandler);
        Header.toggle.setAttribute("aria-expanded", true);
        Header.nav.setAttribute("aria-hidden", false);
        Header.nav.querySelector(".header__nav-close").focus();
        if (Header.overlay) {
            Header.overlay.classList.add("show--");
            document.body.classList.add("no-scroll");
        }
    },

    closeMenu: function (e) {
        Header.el.classList.remove("navOpened");

        // Close
        if (Header.overlay) {
            Header.overlay.classList.remove("show--");
        }
        if (Header.toggle) {
            Header.toggle.setAttribute("aria-expanded", false);
        }
        Header.nav.setAttribute("aria-hidden", true);
        Header.resetSubmenus();
        document.body.classList.remove("no-scroll");
        document.removeEventListener("keydown", this.keydownHandler);
        
    },
    menuConstructor: function () {
        const mainNav = Header.nav.querySelectorAll(".menu-item-has-children");
        if (mainNav && mainNav.length > 0) {
            mainNav.forEach((elt) => {
                const parentLink = elt.querySelector("button");
                const backButton = elt.querySelector('.submenu__back');

                // Click on main nav links
                if (parentLink) {
                    parentLink.addEventListener("click", (e) => {
                        e.preventDefault();
                        const submenu = parentLink.nextElementSibling;
                        if (submenu) {
                            Header.resetSubmenus(submenu);
                            submenu.classList.add("show--");
                            submenu.classList.remove("invisible--");
                            submenu.setAttribute("aria-hidden", "false");
                        }

                        // Manage active link
                        parentLink.classList.add('parent-active');
                        parentLink.setAttribute("aria-expanded", "true");
                    });
                }

                // Click on back button of submenu (mobile only)
                if (backButton) {
                    backButton.addEventListener("click", () => {
                        const submenu = backButton.closest(".submenu");
                        if (submenu) {
                            submenu.classList.remove("show--");
                            submenu.setAttribute("aria-hidden", "true");
                            const timer = setTimeout(() => {
                                submenu.classList.add(
                                    "invisible--"
                                );
                                clearTimeout(timer);
                            }, 300);
                        }

                        const parentLink = submenu.parentElement.querySelector('button');
                        if (parentLink) {
                            parentLink.classList.remove('parent-active');
                            parentLink.setAttribute("aria-expanded", "false");
                            parentLink.focus();
                        }
                    });
                }
            });
        }
    },
    resetSubmenus: function (submenu) {
        // Close other main nav link previously opened
        const oldActiveSubmenus = Header.nav.querySelectorAll('.show--');
        const oldActiveLinks = Header.nav.querySelectorAll('.parent-active');
        if (oldActiveSubmenus) {
            oldActiveSubmenus.forEach(submenuOld => {
                if (submenu) {
                    if (!submenuOld.contains(submenu)) {
                        submenuOld.classList.remove("show--");
                        submenuOld.setAttribute("aria-hidden", "true");
                        submenuOld.classList.add(
                            "invisible--"
                        );
                    }
                } else {
                    submenuOld.classList.remove("show--");
                    submenuOld.setAttribute("aria-hidden", "true");
                    submenuOld.classList.add(
                        "invisible--"
                    );
                }
            });
        }

        if (oldActiveLinks) {
            oldActiveLinks.forEach(parentLinkOld => {
                parentLinkOld.classList.remove('parent-active');
                parentLinkOld.setAttribute("aria-expanded", "false");
            });
        }
    }
};

export default Header;
